import { render, staticRenderFns } from "./Groupmanagement.vue?vue&type=template&id=409ff08b&scoped=true&"
import script from "./Groupmanagement.vue?vue&type=script&lang=js&"
export * from "./Groupmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Groupmanagement.vue?vue&type=style&index=0&id=409ff08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ff08b",
  null
  
)

export default component.exports